import React, { Fragment, useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Row, Badge, Table } from "reactstrap";
import { Package, Truck, CheckCircle, DollarSign } from "react-feather";
import axios from "axios";
import API_BASE_URL from '../../../Config/api';

const StatusStep = ({ icon: Icon, label, completed, date }) => {
    return (
        <div className="d-flex flex-column align-items-center position-relative" style={{ flex: 1 }}>
            <div
                className={`rounded-circle p-2 ${
                    completed ? 'bg-success' : 'bg-light'
                }`}
                style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <Icon
                    size={20}
                    className={completed ? 'text-white' : 'text-muted'}
                />
            </div>
            <small className="mt-2 text-center" style={{ fontSize: '11px' }}>
                {label}
            </small>
            {date && (
                <small className="text-muted" style={{ fontSize: '10px' }}>
                    {new Date(date).toLocaleDateString()}
                </small>
            )}
        </div>
    );
};

const OrderRow = ({ order }) => {
    const isShipped = order.shipped_date || order.is_shipped;
    const isDelivered = order.delivered_date || order.is_delivered;
    const isPaid = order.payment_date || order.is_paid;

    return (
        <tr>
            <td>
                <div className="fw-bold">{order.order_id}</div>
                <small className="text-muted">{order.store_name || 'N/A'}</small>
            </td>
            <td>
                <div className="text-muted" style={{ fontSize: '12px' }}>
                    {order.order_date ? new Date(order.order_date).toLocaleDateString() : 'N/A'}
                </div>
            </td>
            <td>
                <div>€{parseFloat(order.total || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
            </td>
            <td>
                <div className="d-flex align-items-center position-relative" style={{ minWidth: '300px' }}>
                    <StatusStep
                        icon={Package}
                        label="Ordered"
                        completed={true}
                        date={order.order_date}
                    />
                    <div
                        className={`${isShipped ? 'bg-success' : 'bg-light'}`}
                        style={{ height: '2px', flex: 1, margin: '0 -10px', marginTop: '-60px' }}
                    />
                    <StatusStep
                        icon={Truck}
                        label="Shipped"
                        completed={isShipped}
                        date={order.shipped_date}
                    />
                    <div
                        className={`${isDelivered ? 'bg-success' : 'bg-light'}`}
                        style={{ height: '2px', flex: 1, margin: '0 -10px', marginTop: '-60px' }}
                    />
                    <StatusStep
                        icon={CheckCircle}
                        label="Delivered"
                        completed={isDelivered}
                        date={order.delivered_date}
                    />
                    <div
                        className={`${isPaid ? 'bg-success' : 'bg-light'}`}
                        style={{ height: '2px', flex: 1, margin: '0 -10px', marginTop: '-60px' }}
                    />
                    <StatusStep
                        icon={DollarSign}
                        label="Paid"
                        completed={isPaid}
                        date={order.payment_date}
                    />
                </div>
            </td>
        </tr>
    );
};

const OrderPipeline = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/dashboard/order-pipeline`);
            setOrders(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching order pipeline:', error);
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <Row>
                <Col sm="12">
                    <Card>
                        <CardHeader className="pb-0">
                            <h5>Order Pipeline</h5>
                            <span className="text-muted">Track order status from placement to payment</span>
                        </CardHeader>
                        <CardBody>
                            {loading ? (
                                <div className="text-center py-5">Loading orders...</div>
                            ) : orders.length === 0 ? (
                                <div className="text-center py-5">No orders found</div>
                            ) : (
                                <div className="table-responsive">
                                    <Table hover>
                                        <thead>
                                            <tr>
                                                <th>Order ID</th>
                                                <th>Order Date</th>
                                                <th>Total</th>
                                                <th>Status Pipeline</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orders.map((order) => (
                                                <OrderRow key={order.id} order={order} />
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
};

export default OrderPipeline;
